// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notfound-container {
  position: relative;
  background-size: cover;
  background-position: center;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  overflow: hidden;
}
.notfound-container .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1;
}
.notfound-container .content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 2rem;
  max-width: 800px;
}
.notfound-container .content .title {
  font-size: 3rem;
  font-weight: 500;
}
.notfound-container .content .title .line {
  display: inline-block;
  width: 50px;
  height: 2px;
  background: #fff;
  vertical-align: middle;
  margin: 0 1rem;
}
.notfound-container .content .title .line.left-line {
  margin-left: 0;
}
.notfound-container .content .title .line.right-line {
  margin-right: 0;
}
.notfound-container .content .description {
  margin-top: 1rem;
  font-size: 1rem;
  color: #eee;
}
.notfound-container .content .home-button {
  margin-top: 2rem;
  background: #fff;
  color: #000;
  padding: 0.8rem 2rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  font-size: 0.9rem;
}
.notfound-container .content .home-button:hover {
  background: #ddd;
}`, "",{"version":3,"sources":["webpack://./src/pages/PageNotFound/PageNotFound.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,gBAAA;AAAF;AAEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,UAAA;AAAJ;AAGE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AADJ;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAGM;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AADR;AAGQ;EACE,cAAA;AADV;AAIQ;EACE,eAAA;AAFV;AAOI;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AALN;AAQI;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;AANN;AAQM;EACE,gBAAA;AANR","sourcesContent":[".notfound-container {\n  position: relative;\n  background-size: cover;\n  background-position: center;\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n//   font-family: 'Georgia', serif;\n  color: #fff;\n  overflow: hidden;\n\n  .overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.65); \n    z-index: 1;\n  }\n\n  .content {\n    position: relative;\n    z-index: 2;\n    text-align: center;\n    padding: 2rem;\n    max-width: 800px;\n\n    .title {\n      font-size: 3rem;\n      font-weight: 500;\n\n      .line {\n        display: inline-block;\n        width: 50px;\n        height: 2px;\n        background: #fff;\n        vertical-align: middle;\n        margin: 0 1rem;\n\n        &.left-line {\n          margin-left: 0;\n        }\n\n        &.right-line {\n          margin-right: 0;\n        }\n      }\n    }\n\n    .description {\n      margin-top: 1rem;\n      font-size: 1rem;\n      color: #eee;\n    }\n\n    .home-button {\n      margin-top: 2rem;\n      background: #fff;\n      color: #000;\n      padding: 0.8rem 2rem;\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      text-transform: uppercase;\n      font-size: 0.9rem;\n\n      &:hover {\n        background: #ddd;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
